import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from '@headlessui/react';
import { ICONS } from 'shared/constants/images';
import { Icon } from 'shared/ui/icon/icon';
import cls from './language-select.module.scss';
import { useTranslation } from 'hooks';
import { useLocalization } from 'contexts/LocalizationContext';
import { track } from 'utils/mixpanel';
import { useUpdateStripeLanguageMutation } from 'store/api/userApiSlice';
import { StripeLanguageEnum } from 'store/api/apiTypes';

const languages = [
  { code: 'en', name: 'English' },
  { code: 'de', name: 'Deutsch' },
];

export const LanguageSelect: React.FC = () => {
  const { currentLocale } = useTranslation();
  const { changeLocale } = useLocalization();
  const [updateStripeLanguage] = useUpdateStripeLanguageMutation();

  const currentLanguage =
    languages.find(lang => lang.code === currentLocale) || languages[0];

  const handleLanguageChange = async (languageCode: string) => {
    const lang_id =
      languageCode === 'de' ? StripeLanguageEnum.GE : StripeLanguageEnum.EN;
    changeLocale(languageCode);
    await updateStripeLanguage({ lang_id }).unwrap();
    localStorage.setItem('locale', languageCode);
    track('AIS:LEFT_MENU-LANGUAGE-SELECTED');
  };
  return (
    <div className={cls.languageSelector}>
      <Listbox as='div' value={currentLocale} onChange={handleLanguageChange}>
        {({ open }) => (
          <>
            <ListboxButton
              className={`${cls.languageButton} ${open ? cls.open : ''}`}
            >
              <span className={cls.languageCode}>
                {currentLanguage.code.toUpperCase()}
              </span>
              <Icon
                className={open ? '' : cls.open}
                pathToIcon={ICONS.arrowUp}
                size={22}
              />
            </ListboxButton>
            <ListboxOptions
              anchor={{ to: 'top start' }}
              className={cls.languageOptions}
            >
              {languages.map(language => (
                <ListboxOption
                  key={language.code}
                  value={language.code}
                  className={cls.languageOption}
                >
                  <span className={cls.languageName}>{language.name}</span>
                </ListboxOption>
              ))}
            </ListboxOptions>
          </>
        )}
      </Listbox>
    </div>
  );
};
